import { APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { BootstrapperBase } from '@trustedshops/tswp-core-common';
import {
  PageTitleCompositionService,
  RouteSourceService,
  TOKENS,
} from '@trustedshops/tswp-core-ui';

@Injectable()
export class PageTitleCompositionBootstrapper implements BootstrapperBase {
  //#region Ctor
  public constructor(
    @Inject(TOKENS.RouteSourceService)
    private readonly _routeSourceService: RouteSourceService,

    @Inject(TOKENS.PageTitleCompositionService)
    private readonly _pageTitleCompositionService: PageTitleCompositionService
  ) {}
  //#endregion

  //#region Public Methods
  public async initialize(): Promise<void> {
    this._routeSourceService.registerRouteWatcher(() =>
      this._pageTitleCompositionService.update()
    );
  }
  //#endregion
}

/**
 * Bootstrapper for connecting the page title composition service to the route source service.
 */
export const PageTitleCompositionBootstrapperInitializer = [
  PageTitleCompositionBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: BootstrapperBase) => () =>
      initializer.initialize(),
    deps: [PageTitleCompositionBootstrapper],
  },
];
